import { SectionsAnalyticsPage } from "../SectionsAnalyticsPage/index";

const SectionsAnalyticsTimePage = () => (
  <SectionsAnalyticsPage analyticsType="time" />
);

export default SectionsAnalyticsTimePage;
